export function numberToOneDecimalsLocaleString(someNumber: number, locale: Intl.LocalesArgument) {
  return someNumber.toLocaleString(locale, {maximumFractionDigits: 1});
}
